export default __webpack_public_path__ + "static/media/Search_alt.d493646b.svg";